import { render, staticRenderFns } from "./SingleDishMeal.vue?vue&type=template&id=13b28f1f&scoped=true&"
import script from "./SingleDishMeal.vue?vue&type=script&lang=js&"
export * from "./SingleDishMeal.vue?vue&type=script&lang=js&"
import style0 from "./SingleDishMeal.vue?vue&type=style&index=0&id=13b28f1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b28f1f",
  null
  
)

export default component.exports